import http from '../../utils/Http/Http'
import { getAuth } from 'firebase/auth'

export type Schedule = {
	schedule_name: string
	schedule_arn: string
	group_name: string
	state: 'ENABLED' | 'DISABLED'
	creation_date: string
	last_modified_date: string
	target_arn: string
	description: string | null
	schedule_expression: string
	timezone: string
	start_date: string | null
	end_date: string | null
	action_after_completion: string
	target: {
		Arn: string
		Input: string
		RetryPolicy: {
			MaximumEventAgeInSeconds: number
			MaximumRetryAttempts: number
		}
		RoleArn: string
	}
	kms_key_arn: string | null
	flexible_time_window: {
		Mode: string
	}
}

export type FetchSchedulesResponse = {
	schedules: Schedule[]
	total_count: number
}

export async function fetchSchedules(): Promise<FetchSchedulesResponse> {
	const response = await http({
		url: '/scheduler/schedules',
		method: 'get',
		params: {},
	})

	return response.data
}
